import { Application, Route, $Router } from '../../classes';

const getRoleMaps = () => {
    const commerceVanNamespace = `${$Router.getEnvironment()}-shire-ui-ext`;
    return {
        ful: 'Fulfillment',
        fulmon: 'Fulfillment Monitor',
        tnc: 'Testing and Certification',
        ast: 'Assortment',
        [commerceVanNamespace]: 'Commerce Van',
        sourcing: 'Assortment'
    };
}

const hasSubscription = (orgSubs: Array<any>, namespace: string) => {
    return orgSubs.some((app) => {
        return app.namespace && app.namespace === namespace;
    });
};
const resolveUserAppAccess = (userRoles: Array<any>, orgSubscriptions: Array<string>) => {
    return userRoles.reduce((accum, role) => {
        const roleMap = getRoleMaps();
        const roleNamespace = role.split(':')[0];
        const product = roleMap[roleNamespace];
        if (Object.keys(roleMap).includes(roleNamespace)
            && hasSubscription(orgSubscriptions, roleNamespace)
            && !accum.includes(product)) {

            accum.unshift(product);
            return accum
        }
        return accum;
    }, ['Other']);
};

const productMap = {
    'Fulfillment Monitor': 'Fulfillment Monitor',
    'Fulfillment': 'Fulfillment',
    'Assortment': 'Assortment',
    'Assortment UI': 'Assortment',
    'Testing and Certification': 'Testing and Certification',
    'Commerce VAN': 'Commerce Van',
    'Commerce VAN [external]': 'Commerce Van'
};

function getProducts(currentUser) {
    return resolveUserAppAccess(currentUser.roles, currentUser.apps);
}

function getReferralApp() {
    let [app, route]: [Application, Route] = $Router.getAppAndRoute($Router.currentRoute);
    return productMap[app.name] ? productMap[app.name] : 'Other'
}

export {
    getReferralApp,
    getProducts
}